import { Outlet, useLocation } from 'react-router-dom'
import TopBar from './TopBar'
import BottomNav from './BottomNav'

export default function AppLayout() {
  const location = useLocation()

  return (
    <div className="min-h-screen bg-iswara-bg flex flex-col">
      <TopBar />
      <main className="flex-1 pt-14 pb-20 px-4">
        <div className="max-w-2xl mx-auto">
          <Outlet />
        </div>
      </main>
      <BottomNav />
    </div>
  )
}
